import {dateTime} from "services/date";
import {InteractionArea} from "../../../types/InteractionArea";

/**
 * Transform the given Interaction Area by deserializing object properties
 *
 * @internal
 * @param interactionArea
 */
export default function deserializeInteractionArea(interactionArea: any): InteractionArea {
    interactionArea.created_at = dateTime(interactionArea.created_at);
    interactionArea.updated_at = dateTime(interactionArea.updated_at);

    return interactionArea;
}